"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requirePropFactory;

function requirePropFactory(componentNameInError) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/utils/requirePropFactory.js
// module id = 417
// module chunks = 0